import { useState } from "react";
import TotalInviteSent from "./applicant-invited/TotalInviteSent";
import PendingLogin from "./applicant-invited/PendingLogin";
import ApplicantLoggedIn from "./applicant-invited/ApplicantLoggedIn";
import InviteExpired from "./applicant-invited/InviteExpired";
import ModifyInviteModal from "../../../core/common/ModifyInviteModal";
import TimelineModal from "../../../core/common/TimelineModal";
import { Button } from "antd";
import GuideContentArea from "../../../core/common/GuideContentArea";
import {
  dummyData_inProgress,
  dummyData_invited,
  dummyData_loggedIn,
  dummyData_pending,
  dummyData_totalInvited,
  timelineData_invite,
} from "../../../core/data/js/dummy-data";
import TabItems from "../../../core/common/TabItems";
import Footer from "../../../core/common/Footer";
import ApplicantInProgress from "./applicant-invited/ApplicantInProgress";

export const statusColors: Record<string, string> = {
  "Pending Login": "bg-warning",
  "Logged In": "bg-soft-success",
  "Login Expired": "bg-soft-danger",
  "Form Approval": "bg-soft-info",
};

export const pendingList = dummyData_invited?.filter((d) =>
  d?.status?.toLowerCase()?.includes("pending"),
);
export const loggedinList = dummyData_invited?.filter((d) =>
  d?.status?.toLowerCase()?.includes("logged in"),
);
export const expiredList = dummyData_invited?.filter((d) =>
  d?.status?.toLowerCase()?.includes("expired"),
);
export const approvalList = dummyData_invited?.filter((d) =>
  d?.status?.toLowerCase()?.includes("form"),
);

export const ApplicantStats = [
  {
    id: "total_invite_sent",
    label: "Total Invitations",
    // label: "Total Invite Sent",
    count: dummyData_totalInvited?.length || 0,
    component: <TotalInviteSent />,
  },
  {
    id: "pending_login",
    label: "Login Pending",
    // label: "Pending Login",
    count: dummyData_pending?.length || 0,
    component: <PendingLogin />,
  },
  {
    id: "applicant_logged_in",
    label: "Logged In",
    // label: "Logged In",
    count: dummyData_loggedIn?.length || 0,
    component: <ApplicantLoggedIn />,
  },
  {
    id: "in_progress",
    label: "In Progress",
    // label: "Logged In",
    count: dummyData_inProgress?.length || 0,
    component: <ApplicantInProgress />,
  },
  // {
  //   id: "invite_expired",
  //   label: "Expired Invitations",
  //   // label: "Invite Expired",
  //   count: expiredList?.length || 0,
  //   component: <InviteExpired />,
  // },
  // {
  //   id: "form_approval",
  //   label: "Application Approval",
  //   // label: "Form Approval",
  //   count: approvalList?.length || 0,
  //   component: <ApplicantFormApproval />,
  // },
];

// guideData
const guideData = [
  {
    title: "Stage 1 - Invites Sent",
    steps: [
      "All invites sent will by default show a pending login status. The invite will be sent to the candidate, and they have not yet opened the link and logged in to the account.",
    ],
  },
  {
    title: "Stage 2 - Pending Log In",
    steps: [
      "The invite will be sent to the candidate, and they have not yet opened the link and logged in to the account.",
    ],
  },
  {
    title: "Stage 3 - Logged In",
    steps: [
      "The invite has been opened by the candidate, and they have proceeded to fill the form. Form filling is in progress.",
    ],
  },
  {
    title: "Stage 4 - Invites Stopped/Expired",
    steps: [
      "All invites which were not filled by the candidate will expire after a certain period of time.",
      "The default time period is set at 15 working days. If you would like to change this time period, you can do so in the master settings tab (sub tab).",
      "All invites stopped will be added to this bucket and can be resumed at a later date.",
    ],
  },
  {
    title: "Stage 5 - Form Submitted | Awaiting HR Approval",
    steps: [
      "The form has been successfully filled by the applicant and it is now submitted.",
      "The case will either go directly to Aupertz for starting of the background check or it will go to the client's HR for a pre-approval before it gets sent to Aupertz.",
      "By default it will go to Aupertz directly.",
      "If you would like HR approval, this can be triggered in the master settings tab (sub tab).",
    ],
  },
];

const ApplicantCaseTracking = () => {
  // const [itemList, setItemList] = useState(dummyData_invited);

  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [showModifyInvite, setShowModifyInvite] = useState<boolean>(false);
  const [showGuide, setShowGuide] = useState<boolean>(false);

  const [activeTab, setActiveTab] = useState<string>(
    ApplicantStats[0]?.id ?? "",
  );
  const activeItem = ApplicantStats.find((i) => i.id == activeTab);
  const activeComponent = activeItem ? activeItem.component : <></>;

  return (
    <div className="page-wrapper">
      <div className="content">
        <>
          {/* Tabs */}
          <TabItems
            tabList={ApplicantStats}
            activeTab={activeTab}
            handleClick={(d) => {
              setActiveTab(d.id);
              // localStorage.setItem("active-track-case-tab", d.id);
            }}
          />

          {/* Guide Container */}
          <>
            <div className="text-end">
              <Button
                className="border-secodary"
                onClick={() => setShowGuide((prev) => !prev)}
              >
                <i className="ti ti-info-circle-filled fs-16"></i>
                <div className="pb-1 ">Guide</div>
              </Button>
            </div>

            <GuideContentArea
              maxHeight={"400px"}
              showGuide={showGuide}
              handleClick={() => setShowGuide(false)}
              title={"Applicant Invited"}
              content={
                <div>
                  <div className="pb-2">
                    The applicant will receive the user credentials to access
                    the Aupertz applicant portal through an invite.
                  </div>
                  <div className="pb-4">
                    The applicant will log in to fill the applicant form (ADF)
                    and submit all the required data for screening.
                  </div>
                  {guideData?.map((d) => (
                    <div className="mb-3" style={{ maxWidth: "900px" }}>
                      <h6 className="fw-semibold pb-1">{d.title}</h6>
                      {d?.steps?.map((i, idx) => (
                        <div className="d-flex gap-2 py-1">
                          <div>{idx + 1}.</div>
                          <div>{i}</div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              }
            />
          </>

          {/* Tab Content */}
          <div className="mt-2">{activeComponent}</div>

          {/* Timeline Modal */}
          {showTimeline && (
            <TimelineModal
              timelineData={timelineData_invite}
              onClose={() => setShowTimeline(false)}
            />
          )}
          {/* Modify Invite Modal */}
          {showModifyInvite && (
            <ModifyInviteModal
              handleClose={() => setShowModifyInvite(false)}
              handleSubmit={(d) => {
                console.log(d);
                setShowModifyInvite(false);
              }}
            />
          )}
        </>
      </div>

      {/* ---- Footer ---- */}
      <Footer />
    </div>
  );
};
export default ApplicantCaseTracking;
